import { CustomCardView } from "./CustomCardView";
import { Box, Divider, IconButton, Stack } from "@mui/material";
import { CustomTextView } from "./CustomTextView";
import { ReactElement } from "react";
import { COLOR_VERY_LIGHT_GRAY } from "../../data/colors/Colors";

interface props {
  title: string;
  startIcon?: ReactElement;
  editIcon?: ReactElement;
  customIcon?: ReactElement;
  onEditButtonClicked?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  height?: number | string;
  maxHeight?: number;
  minHeight?: number;
  layout?: ReactElement;
  hasDivider?: boolean;
  background?: string;
  borderRadius?: number;
  hasIconButtonAsParent?: boolean;
  justifyContent?: string;
}

export const CustomTitledView: React.FC<props> = ({
  title,
  startIcon,
  editIcon,
  customIcon,
  onEditButtonClicked,
  height,
  maxHeight,
  minHeight,
  layout,
  borderRadius,
  hasDivider = true,
  background = COLOR_VERY_LIGHT_GRAY,
  hasIconButtonAsParent = true,
  justifyContent,
}: props) => {
  return (
    <CustomCardView
      padding={0}
      borderRadius={borderRadius}
      height={height}
      maxHeight={maxHeight}
      minHeight={minHeight}
      background={background}
      width={"100%"}
      children={
        <Stack
          spacing={0}
          height={"100%"}
          justifyContent={
            justifyContent
              ? justifyContent
              : layout
                ? "space-between"
                : "center"
          }
          display={"flex"}
        >
          <Stack>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              p={2}
            >
              <Stack spacing={1} alignItems={"center"} direction={"row"}>
                {editIcon && startIcon}
                <CustomTextView text={title} fontWeight="600" variant="h6" />
              </Stack>

              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                {customIcon && <Box>{customIcon}</Box>}
                {editIcon && (
                  <Box>
                    {hasIconButtonAsParent ? (
                      <IconButton onClick={onEditButtonClicked}>
                        {editIcon}
                      </IconButton>
                    ) : (
                      <>{editIcon}</>
                    )}
                  </Box>
                )}
              </Stack>
            </Stack>
            {hasDivider && <Divider />}
          </Stack>
          {layout}
        </Stack>
      }
    />
  );
};
